import React from 'react';

import Icon from '../Icon/Icon';

const VeevConnectedIcon = (props) => {
    return (
        <Icon width='48' height='48' fill='none' {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M20.3615 16.9804C19.8845 16.9804 19.349 17.0703 18.7549 17.25C19.2063 10.25 19.761 6.75 20.4189 6.75H27.5808C28.2388 6.75 28.7934 10.25 29.2449 17.25C28.6508 17.0703 28.1152 16.9804 27.6383 16.9804H20.3615Z'
                stroke='#34303D'
                strokeWidth='2'
                strokeLinejoin='round'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19.6686 41.25C19.0699 41.25 18.7637 34.6791 18.75 21.5373L18.7504 19.3115C18.7512 18.7021 18.7526 18.08 18.7545 17.4453C19.3486 17.3151 19.8842 17.25 20.3611 17.25H27.6379C28.1149 17.25 28.6504 17.3151 29.2445 17.4453C29.2469 18.2387 29.2485 19.0124 29.2491 19.7662L29.249 21.5373C29.2354 34.6791 28.9292 41.25 28.3305 41.25H19.6686Z'
                fill='#00D1D2'
                stroke='#34303D'
                strokeWidth='2'
                strokeLinejoin='round'
            />
            <path
                d='M24.75 11.25C24.75 10.8358 24.4142 10.5 24 10.5C23.5858 10.5 23.25 10.8358 23.25 11.25V14.25C23.25 14.6642 23.5858 15 24 15C24.4142 15 24.75 14.6642 24.75 14.25V11.25Z'
                fill='#34303D'
            />
        </Icon>
    );
};

export default VeevConnectedIcon;
